/** 組織区分（ロール） */
export const ORGANIZATION_TYPES = ['基金', '漁協', '水産庁', '沖縄県'] as const;
export type OrganizationType = (typeof ORGANIZATION_TYPES)[number];

/** ログインユーザー（GET /api/auth/me） */
export interface AuthUser {
  id: number | string;
  name: string;
  loginId: string;
  organizationType: OrganizationType;
  /** 漁協ユーザーの場合の事業実施者 ID */
  businessOperatorId: number | string | null;
  /** 表示用の組織名（API が返す場合） */
  organizationName?: string | null;
}

/** 2段階認証の確認待ち（POST /api/auth/login の応答） */
export interface MfaPendingResult {
  /** verify＝確認コード入力待ち、setup＝認証アプリ登録待ち */
  mfaPending: 'verify' | 'setup';
  loginId: string;
  name: string;
}

export type LoginResult = AuthUser | MfaPendingResult;

export function isMfaPending(r: LoginResult | null | undefined): r is MfaPendingResult {
  return !!r && 'mfaPending' in r;
}

export interface LoginInput {
  loginId: string;
  password: string;
}

/** 組織区分ごとの表示名（ヘッダー等） */
export const ORGANIZATION_LABELS: Record<OrganizationType, string> = {
  基金: '沖縄県漁業振興基金',
  漁協: '漁業協同組合',
  水産庁: '水産庁',
  沖縄県: '沖縄県',
};

/** 閲覧のみのロール */
export const READ_ONLY_ROLES: readonly OrganizationType[] = ['水産庁', '沖縄県'];

export function hasRole(user: AuthUser | null | undefined, roles?: readonly OrganizationType[]): boolean {
  if (!user) return false;
  if (!roles || roles.length === 0) return true;
  return roles.includes(user.organizationType);
}
